import { SET_UI, SET_ERROR, UPDATE_TIMEOUT_MESSAGE, SET_APP_STATE } from '../constants/actions'
import { MODE } from '../constants/mode'
import { UI } from '../constants/ui'
import { getMode } from '../hooks/mode'

interface State {
  uiState: UI
  error?: string
  errorTitle?: string
  showButton?: boolean
  isTimeOutMessage: boolean
}

const initialView = getMode() === MODE.MOBILE ? UI.LANGUAGE_SELECTION : UI.MAIN

const initialState: State = { uiState: initialView, error: '', errorTitle: '', showButton: false, isTimeOutMessage: false }
const reducer = (state: State = initialState, action: any) => {
  switch (action.type) {
    case SET_UI: {
      const uiState = action.payload === undefined ? UI.MAIN : action.payload
      return { ...initialState, uiState }
    }
    case SET_ERROR: {
      const error = action.payload ? action.payload.error : ''
      const errorTitle = action.payload ? action.payload.errorTitle : ''
      const showButton = !!action.payload.showButton
      return { ...initialState, uiState: UI.ERROR, error, errorTitle, showButton }
    }
    case UPDATE_TIMEOUT_MESSAGE:
      return { ...state, isTimeOutMessage: action.payload }
    case SET_APP_STATE: {
      if (action.payload.ui) {
        return { ...initialState, ...action.payload.ui }
      }
    }
    default:
      return state
  }
}

export default reducer
